module.exports = __webpack_public_path__ + "img/index_banner.5849176d.png";